module.exports = __webpack_public_path__ + "static/media/lupa_grey.88410079.svg";